import { LastPage } from "./types";

export function getNavLastPage(state): LastPage {
  return state.lastPage;
}
